<div id="app">
  @if (showHeaderAndSidebar) {
    <div>
      <scitis-header (sidebarStatusKey)="setSidebarStatusKey($event)"></scitis-header>
    </div>
  }

  <div
    class="sidebar-wrapper"
    [ngClass]="{'sidebar-wrapper-menu-opened': isSidebarOpen === true}">
    @if (showHeaderAndSidebar) {
      <div>
        <scitis-sidebar class="sidebar"></scitis-sidebar>
        <div class="mobile-dimmer" (click)="closeMobileDimmer()"></div>
      </div>
    }

    <main class="main-view" #mainView>
      <router-outlet></router-outlet>
    </main>
    <scitis-loading-indicator></scitis-loading-indicator>
    <scitis-notification-container></scitis-notification-container>
    <scitis-branding-preview-toast></scitis-branding-preview-toast>
  </div>
</div>
